// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_1e7it","icon":"index_icon_3erwP","setIcon":"index_setIcon_2SU2d","setIconActive":"index_setIconActive_2BOs8","link":"index_link_3-Qdl"};